import React from 'react';
import { Row, Col, AutoComplete, Input } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Team from './Team';
import HomePageLayout from '../Layout/HomePageLayout';
import { getServiceEntryByDomain } from '../../apis/serviceEntry';
import { searchListApi } from '../../actions/app.action';
import debounce from 'lodash.debounce';

console.log('debounce', debounce)
class Home extends React.Component {

  constructor() {
    super();
    this.state = {
      typingStr: '',
      apiSearchList: [],
      serviceList: [],
    }
    this.doSearch = this.doSearch.bind(this);
    this.handleApiSearchClick = this.handleApiSearchClick.bind(this);
  }

  componentDidMount() {
    this.loadService();
  }

  loadService = async () => {
    try {
      const { data } = await getServiceEntryByDomain()  
      if (data && data.length > 0) {
        data.sort((a, b) => b.service_entries.length - a.service_entries.length)
        this.setState({
          serviceList: data,
        }) 
      }
    } catch (error) {
      console.log('error', error);
    }
    
  }

  loadTeams = () => {
    console.log("Load team");
    this.props.loadTeams();
  }

  handleSearchBtnClick = (e) => {
    // logger.debug('search button clicked');
    this.doSearch();
  }


  doSearch = (value) => {
    if (value !== '') {
      console.log('searching ....');
      console.log(this.props);
      this.props.searchListApi(value).then(response => {
        if (response?.payload?.result) {
          const result = response.payload.result.map((item) => {
            return {
              value: item.id,
              label: <><b>{item.httpMethod}</b>: {item.baseUrl} - {item.summary} <b>({item.serviceEntryName})</b></>
            }
          });
          this.setState({ apiSearchList: result });
        }
      })
    }
  }

  handleApiSearchClick = (id) => {
    const { user } = this.props;
    if (!user) {
      this.props.history.push({ pathname: `/apis/${id}` });
    } else {
      this.props.history.push({ pathname: `/admin/apis/${id}`});
    }
  }


  handleInputChange = (e) => {
    // logger.debug('input changed');
    this.setState(
      { typingStr: e.target.value },
      () => {
        this.doSearch();
      })
  }

  render() {
    const { user } = this.props;
    const { apiSearchList, serviceList } = this.state;

    return (
      <HomePageLayout>
        <Row justify="center">
          <Col xl={12} md={12}>
            <AutoComplete
              style={{ width: '100%', height: '44px' }}
              onSearch={debounce(this.doSearch, 1000)}
              options={apiSearchList}
              onSelect={this.handleApiSearchClick}
            >
              <Input.Search size="large" placeholder="Search apis contain (full text).." enterButton />
            </AutoComplete>
          </Col>
        </Row>
        <div>
          {
            serviceList && serviceList.map((service, key) => {
              return (
              <Team 
                service={service} 
                user={user} 
                key={key}
              />)
            })
          }
        </div>
      </HomePageLayout>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  searchListApi: (text) => dispatch(searchListApi(text))
})

const mapStateToProps = state => ({
  user: state.app.user
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
